import { Formatter, FormatterEx } from 'slickgrid';

const DEFAULTS = {
  trueValue: 'Yes',
  falseValue: 'No',
  nullValue: '',
};

const TRUTHY = [true, 'true', 'True', 'TRUE', 'yes', 'Yes', 'YES'];

const FALSY = [false, 'false', 'False', 'FALSE', 'no', 'No', 'NO'];

export interface BoolFormatterOptions {
  trueValue?: string;
  falseValue?: string;
  nullValue?: string;
  trueIfHasValue?: boolean;
  falseIfHasNoValue?: boolean;
}

export function bool<T>(opts: BoolFormatterOptions) {
  const vals = { ...DEFAULTS, ...opts };

  const result: FormatterEx = function boolFormatter(
    row,
    cell,
    value,
    columnDef,
    data,
  ) {
    if (opts.trueIfHasValue) {
      value = value != null;
    }
    if (opts.falseIfHasNoValue) {
      value = value == null;
    }

    return TRUTHY.indexOf(value) > -1
      ? vals.trueValue
      : FALSY.indexOf(value) > -1
        ? vals.falseValue
        : vals.nullValue;
  };

  result.filterFormattedData = true;

  return result;
}
